import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import staticPages from './modules/staticPages'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        app,
        staticPages,
    },
    strict: debug,
})